module.exports = {"pathContext":{}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/pack-e-commerce.json
// module id = 345
// module chunks = 135186722866668